// src/pages/SongDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";

export default function SongDetail() {
  const { userId, songId } = useParams();
  const [song, setSong] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [copyMsg, setCopyMsg] = useState("");
  const navigate = useNavigate();


  // Estados para edición
  const [isEditing, setIsEditing] = useState(false);
  const [coverUrl1, setCoverUrl1] = useState("");
  const [coverUrl2, setCoverUrl2] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState("");

  useEffect(() => {
    const cargarCancion = async () => {
      try {
        setLoading(true);
        setError("");

        const ref = doc(db, "usuarios", userId, "canciones", songId);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setError("La canción no existe.");
          return;
        }

        const data = snap.data();
        const songData = {
          id: snap.id,
          userId,
          ...data,
          fechaCreacion: data.fechaCreacion?.toDate?.() || null,
          fechaSubida: data.fechaSubida?.toDate?.() || null,
        };
        setSong(songData);

        // Inicializar campos editables
        setCoverUrl1(songData.coverUrl || "");
        setCoverUrl2(songData.coverUrl02 || "");
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    cargarCancion();
  }, [userId, songId]);

  const handleGuardar = async () => {
    if (!song) return;
    try {
      setSaving(true);
      setSaveMsg("");

      const ref = doc(db, "usuarios", userId, "canciones", songId);
      await updateDoc(ref, {
        coverUrl: coverUrl1 || "",
        coverUrl02: coverUrl2 || "",
      });

      // Actualizar estado local
      setSong((prev) =>
        prev
          ? {
              ...prev,
              coverUrl: coverUrl1 || "",
              coverUrl02: coverUrl2 || "",
            }
          : prev
      );

      setIsEditing(false);
      setSaveMsg("Guardado correctamente.");
    } catch (e) {
      console.error(e);
      setSaveMsg("Error al guardar: " + e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancelar = () => {
    if (!song) return;
    setCoverUrl1(song.coverUrl || "");
    setCoverUrl2(song.coverUrl02 || "");
    setIsEditing(false);
    setSaveMsg("");
  };

   const irASubirCancion = () => {
    navigate(`/subircancion/${userId}/${songId}`);
  };
  const irASubirDos = () => {
    navigate(`/upload-two/${userId}/${songId}`, {
      state: { userId, songId },
    });
  };


  const handleCopyLetra = async () => {
  if (!song?.letra) return;

  try {
    await navigator.clipboard.writeText(song.letra);
    setCopyMsg("Letra copiada al portapapeles ✔");
    setTimeout(() => setCopyMsg(""), 2000);
  } catch (e) {
    console.error(e);
    setCopyMsg("No se pudo copiar 😕");
    setTimeout(() => setCopyMsg(""), 2000);
  }
};


  if (loading) return <p>Cargando canción...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!song) return <p>No se encontró la canción.</p>;

   const handleVerUsuario = () => {
    
    navigate(`/users/${userId}`);
  };

  const estado =
    song.coverUrl || song.coverUrl02 ? "Generada" : "Pendiente";

  return (
    <div>
      <Link to="/songs">← Volver a canciones</Link>

      <h1 style={{ marginTop: 16 }}>{song.titulo || "Sin título"}</h1>
      <p>
        <strong>Usuario ID:</strong> {song.userId}
      </p>
      <p>
        <strong>Canción ID:</strong> {song.id}
      </p>
      <p>
        <strong>Task ID:</strong> {song.taskId || "-"}
      </p>
      <p>
        <strong>Estilo:</strong> {song.estilo || "-"}
      </p>
      <p>
        <strong>Estado:</strong> {estado}
      </p>
      <p>
        <strong>Fecha creación:</strong>{" "}
        {song.fechaCreacion ? song.fechaCreacion.toLocaleString() : "-"}
      </p>

       <div style={{ margin: "12px 0" }}>
        <button
          onClick={handleVerUsuario}
         
        >
          Ver usuario
        </button>
      </div>

      <hr style={{ margin: "16px 0" }} />

      {/* Botones de edición */}
      <div style={{ marginBottom: 12 }}>
        {!isEditing && (
          <button onClick={() => setIsEditing(true)}>Editar URLs</button>
        )}
        {isEditing && (
          <>
            <button
              onClick={handleGuardar}
              disabled={saving}
              style={{ marginRight: 8 }}
            >
              {saving ? "Guardando..." : "Guardar"}
            </button>
            <button onClick={handleCancelar}>Cancelar</button>
          </>
        )}
        {saveMsg && (
          <p style={{ marginTop: 8, fontSize: 13 }}>{saveMsg}</p>
        )}
      </div>



      {/* Campos de coverUrl editables / solo lectura */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 12 }}>
          <p>
            <strong>Cover URL 1</strong>
          </p>
          {isEditing ? (
            <input
              type="text"
              value={coverUrl1}
              onChange={(e) => setCoverUrl1(e.target.value)}
              style={{ width: "100%", padding: 6 }}
            />
          ) : (
            <p style={{ wordBreak: "break-all" }}>
              {song.coverUrl || "(vacío)"}
            </p>
          )}
          {coverUrl1 && (
            <audio
              controls
              style={{ width: "100%", marginTop: 4 }}
              src={coverUrl1}
            />
          )}
        </div>

        <div style={{ marginBottom: 12 }}>
          <p>
            <strong>Cover URL 2</strong>
          </p>
          {isEditing ? (
            <input
              type="text"
              value={coverUrl2}
              onChange={(e) => setCoverUrl2(e.target.value)}
              style={{ width: "100%", padding: 6 }}
            />
          ) : (
            <p style={{ wordBreak: "break-all" }}>
              {song.coverUrl02 || "(vacío)"}
            </p>
          )}
          {coverUrl2 && (
            <audio
              controls
              style={{ width: "100%", marginTop: 4 }}
              src={coverUrl2}
            />
          )}
        </div>
      </div>

     
      <button
        onClick={irASubirCancion}
        style={{ marginRight: 8 }}
      >
         Subir MP3 (coverurl)
      </button>

       <button
        onClick={irASubirDos}
        style={{ marginRight: 8 }}
      >
         Subir MP3 B (coverurl)
      </button>


      {/* Demos si existen */}
      {song.demoUrl && (
        <div style={{ marginBottom: 12 }}>
          <p>
            <strong>Demo URL</strong>
          </p>
          <audio
            controls
            style={{ width: "100%" }}
            src={song.demoUrl}
          />
        </div>
      )}

      {song.demoUrl02 && (
        <div style={{ marginBottom: 12 }}>
          <p>
            <strong>Demo URL 2</strong>
          </p>
          <audio
            controls
            style={{ width: "100%" }}
            src={song.demoUrl02}
          />
        </div>
      )}

      <hr style={{ margin: "16px 0" }} />

      <div style={{ marginBottom: 16 }}>
        <p>
          <strong>Prompt:</strong>
        </p>
        <pre
          style={{
            background: "#f7f7f7",
            padding: 12,
            borderRadius: 6,
            whiteSpace: "pre-wrap",
          }}
        >
          {song.prompt || "-"}
        </pre>
      </div>

      <div>
        <p>
          <strong>Letra:</strong>
        </p>
        <button
        onClick={handleCopyLetra}
        style={{ marginBottom: 8 }}
    >
        Copiar letra
    </button>
    {copyMsg && (
        <span style={{ marginLeft: 8, fontSize: 12 }}>{copyMsg}</span>
    )}
        <pre
          style={{
            background: "#f7f7f7",
            padding: 12,
            borderRadius: 6,
            whiteSpace: "pre-wrap",
          }}
        >
          {song.letra || "-"}
        </pre>
      </div>
    </div>
  );
}
